import { useEffect, useState } from 'react';

import {
    Alert,
    Button,
    Checkbox,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel
} from '@mui/material';
import { useConfig, useNotification, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { useEventBus } from '../../../../hooks/use-event-bus';
import FormsService from '../../../../services/forms-service/forms-service';
import { CancelButton, Dialog } from './styles';

export default function ModalConsent() {
    const [open, setOpen] = useState(false);
    const [patientId, setPatientId] = useState<number | null>(null);
    const [checked, setChecked] = useState(false);

    const { listen, publish } = useEventBus();
    const { showSuccess, showError } = useNotification();

    const { config } = useConfig();
    const oidc = useOidcWithAdmin();

    useEffect(() => {
        return listen('formsDialog', (event: any) => {
            const data = event.data as { type: string; patientId: number };

            if (data.type === 'consent') {
                setOpen(true);
                setChecked(false);
                setPatientId(data.patientId);
            }
        });
    }, [listen]);

    const handleClose = () => {
        setOpen(false);
    };

    const submit = async () => {
        const formsService = FormsService.getInstance(config, oidc.oidcService);
        setOpen(false);
        try {
            await formsService.updatePatientConsent(patientId!);
            publish({ messageType: 'forms', data: { type: 'reload' } });
            showSuccess('The consent has been successfully received.');
        } catch (error) {
            showError('Failed to receive the consent.');
        }
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Dependent - Consent</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert severity='error'>
                        This dependent is 18+ and is hidden from the responsible party. To get their forms filled out
                        you either need to get consent from this patient to let their responsible party manage their
                        forms or move them to be an independent adult patient in the PMS.
                    </Alert>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checked}
                                onChange={e => {
                                    setChecked(e.target.checked);
                                }}
                            />
                        }
                        label='By checking this box you acknowledge that you have received consent from this patient to let their responsible party manage their forms.'
                    />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleClose}>Cancel</CancelButton>
                <Button variant='contained' onClick={submit} disableElevation disabled={!checked}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
}
